import { render } from "./EndOfMonthTrsxnModal.vue?vue&type=template&id=573c06b6"
import script from "./EndOfMonthTrsxnModal.vue?vue&type=script&lang=js"
export * from "./EndOfMonthTrsxnModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__